"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["className", "nextURL", "nextLabel", "previousURL", "previousLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArticlePagination = function ArticlePagination(_ref) {
  var className = _ref.className,
      nextURL = _ref.nextURL,
      nextLabel = _ref.nextLabel,
      previousURL = _ref.previousURL,
      previousLabel = _ref.previousLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("footer", _extends({
    className: (0, _classnames.default)(className, "p-article-pagination")
  }, props), previousURL && previousLabel && /*#__PURE__*/_react.default.createElement("a", {
    className: "p-article-pagination__link--previous",
    href: previousURL
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__label"
  }, "Previous"), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__title"
  }, previousLabel)), nextURL && nextLabel && /*#__PURE__*/_react.default.createElement("a", {
    className: "p-article-pagination__link--next",
    href: nextURL
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__label"
  }, "Next"), /*#__PURE__*/_react.default.createElement("span", {
    className: "p-article-pagination__title"
  }, nextLabel)));
};

var _default = ArticlePagination;
exports.default = _default;